import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import styles from './Star.module.less';

const Star = ({ width, ...otherProps }) => {
  return (
    <div className={styles.star} {...otherProps}>
      <Icon name="star" className={styles.bg} />

      <div
        className={styles.full}
        style={{ width: (width * 100).toFixed(0) + '%' }}
      >
        <Icon name="star" />
      </div>
    </div>
  );
};
Star.displayName = 'Star';
Star.propTypes = {
  width: PropTypes.number.isRequired,
};

export default Star;
